module.exports = __webpack_public_path__ + "img/in-chinatest.8e35e9ee.png";